<nb-card [nbSpinner]="isCreating">
  <nb-card-header>
    <fa-icon icon="close" (click)="exit($event)" class="exit-icon"></fa-icon>
    <h3>{{ "Step {step}" | translate:{ step: level} }} / 2</h3>
  </nb-card-header>
  <nb-card-body>
    @if (errorMessage) {
      <div class="row">
        <div class="col-md-12">
          <div class="error-message">{{ errorMessage }}</div>
        </div>
      </div>
    }

    <!-- ROUND NAME -->
    <div class="row name-input">
        <div class="col-md-6 title-input">
        <span>{{ 'Title' | translate }} : </span>
        <input
          type="text" class="form-control name-input-field" [(ngModel)]="roundName"
          placeholder="{{ 'pages.workflow.round-name' | translate }}"
          />
        </div>
        @if (level === 1) {
          <div class="col-md-6 custom-name">
            <span [title]="'You can customize validation round title' | translate">({{ 'You can customize validation round title' | translate }})</span>
          </div>
        }
        @if (level === 2) {
          <div class="col-md-6 proposed-total">
            {{ getProposedTotalDisplay() }}
          </div>
        }
      </div>

      <!-- PROJECT CODE -->
      @if (projectCodeRequired) {
        <div class="row name-input">
          <div class="col-md-6 title-input">
            <span>{{ 'pages.workflow.create-round.project-code' | translate }} : </span>
            <input
              type="text" class="form-control name-input-field" name="projectCode" [(ngModel)]="projectCode"
              placeholder="{{ 'pages.workflow.create-round.project-code' | translate }}"
              #projectCodeInput="ngModel"
              />
          </div>
        </div>
      }

      <!-- TAGS CHOICE-->
      @if (level === 1) {
        <div class="row">
          <div class="col">
            <div class="create-round-form-box">
              <table class="table create-round-table">
                @for (tag of investmentTags; track tag) {
                  @if (getTotalTagProposedCount(tag.id)) {
                    <tr>
                      <td>
                        <input type="checkbox" [checked]="isTagSelected(tag.id)" (click)="selectTag(tag.id)"/>
                      </td>
                      <td class="text-left">
                        <span
                          class="investment-tag"
                          [style.backgroundColor]="tag.background_color"
                          [class]="tag.background_color ? styleService.textColorBasedOnBgColor(tag.background_color) : 'black'"
                          >
                          {{ tag.name }}
                        </span>
                      </td>
                      <td>
                        {{ getTotalTagProposedCount(tag.id) }} {{ 'pages.workflow.invests-for' | translate }}
                        {{ getTotalTagProposedAmount(tag.id) | ngxCurrency:currency }}
                      </td>
                    </tr>
                  }
                }
              </table>
            </div>
          </div>
        </div>
      }

      <!-- STEPS MANAGEMENT -->
      @if (level === 2) {
        <div class="row">
          <div class="col">
            <div class="create-round-form-box">
              <table class="table create-round-table">
                @for (step of steps; track step) {
                  <tr>
                    <td>
                      <div class="step-order">{{ step.order }}</div>
                      <div class="spin">
                        <div
                          class="spin-item"
                          (click)="setStepUp(step)"
                          [ngClass]="(step.order === 1) ? 'disabled' : ''"
                          >
                          <fa-icon icon="chevron-up"></fa-icon>
                        </div>
                        <div
                          class="spin-item"
                          (click)="setStepDown(step)"
                          [ngClass]="(step.order === steps.length) ? 'disabled' : ''"
                          >
                          <fa-icon icon="chevron-down"></fa-icon>
                        </div>
                      </div>
                    </td>
                    <td>
                    </td>
                    <td class="text-left">
                      {{ step.name }}
                    </td>
                    <td>
                      <select class="form-control" [value]="getStepMode(step)" (change)="setStepMode($event, step)" [disabled]="step.is_locked || isLastNoGoStep(step)">
                        <option value="-1">{{ 'pages.workflow.disable-step' | translate }}</option>
                        <option value="0">{{ 'pages.workflow.info-step' | translate }}</option>
                        <option value="1">{{ 'pages.workflow.go-no-go-step' | translate }}</option>
                      </select>
                    </td>
                  </tr>
                }
                @for (step of outSteps; track step) {
                  <tr class="out-steps">
                    <td>
                    </td>
                    <td>
                    </td>
                    <td class="text-left">
                      {{ step.name }}
                    </td>
                    <td>
                      <select class="form-control" [value]="getStepMode(step)" (change)="setStepMode($event, step)" [disabled]="step.is_locked">
                        <option value="-1">{{ 'pages.workflow.disable-step' | translate }}</option>
                        <option value="0">{{ 'pages.workflow.info-step' | translate }}</option>
                        <option value="1">{{ 'pages.workflow.go-no-go-step' | translate }}</option>
                      </select>
                    </td>
                  </tr>
                }
              </table>
            </div>
          </div>
        </div>
      }
    </nb-card-body>

    <!-- PREVIOUS AND NEXT BUTTONS -->
    <nb-card-footer class="text-right">

      <!-- ERRORS -->
      <div class="row text-center">
        <div class="col">
          @if (cantGoNextReason()) {
            <div class="col-12 mb-2 go-next-error">
              {{ cantGoNextReason() }}
            </div>
          }
        </div>
      </div>

      <button nbButton (click)="previousLevel($event)" class="ms-1 previous-btn">
        @if (level === 1) {
          {{ 'Cancel' | translate }}
        }
        @if (level === 2) {
          {{ 'pages.workflow.create-round.previous' | translate }}
        }
      </button>
      <button nbButton (click)="nextLevel($event)" class="ms-3 next-btn" [disabled]="!canGoNext()">
        @if (level === 1) {
          {{ 'pages.workflow.create-round.next' | translate }}
        }
        @if (level === 2) {
          {{ 'pages.workflow.create-round.create' | translate }}
        }
      </button>
    </nb-card-footer>
  </nb-card>
